module.exports = __webpack_public_path__ + "img/ywt_list_img2.0e1b493.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/saasIntroduction/ywt_list_img2.png
// module id = rLSq
// module chunks = 136